import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createTenantReport } from "api/tenants";
import { queryKeys } from "hooks/queryKeys";

export const useCreateTenantReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createTenantReport,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tenant-reports"] });
      // Refresh both quota scopes so any consumption from this application is
      // reflected immediately: organization pool (Step 5 summary + Quotas
      // page) and advisor allocation (Dashboard StatsCard chips).
      queryClient.invalidateQueries({
        queryKey: queryKeys.organization.credits(),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.accounts.credits(),
      });
    },
  });
};
